import React, { useState } from 'react';
import { useNavigateWithFilters } from '../../utils/dashboardNav';
import { useUnseenAnnouncements } from '../../hooks/useAnnouncements';
import { invalidateAnnouncementsSummary, markAnnouncementsSeen } from '../../api/announcementsApi';

/**
 * ホームの小さなポップアップ「お知らせがあります」。サーバーの未閲覧数で出す（端末をまたいで同じ）。
 * タップで 設定 → お知らせ。× は「見た」ことにして、次のお知らせまで出ない。
 */
export default function UpdatesBanner() {
  const navigate = useNavigateWithFilters();
  const unseen = useUnseenAnnouncements();
  const [dismissed, setDismissed] = useState(false);
  if (dismissed || unseen === 0) return null;

  const dismiss = async () => {
    setDismissed(true);
    try {
      await markAnnouncementsSeen();
      invalidateAnnouncementsSummary();
    } catch {
      // offline: the popup comes back next time, which is fine
    }
  };

  return (
    <div className="updates-banner" role="status">
      <button type="button" className="updates-banner-main" onClick={() => navigate('/settings/updates')}>
        <span className="updates-banner-ic">📣</span>
        <span className="updates-banner-t">お知らせがあります</span>
        <span className="updates-banner-d">タップして内容を見る</span>
      </button>
      <button type="button" className="updates-banner-x" aria-label="閉じる" onClick={dismiss}>
        ×
      </button>
    </div>
  );
}
